import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
export function ReportActivityList({ api, report }) {
    const [events, setEvents] = useState(report.activity), [cursor, setCursor] = useState(report.activity_next_cursor);
    const [busy, setBusy] = useState(false), [error, setError] = useState('');
    async function more() {
        if (!cursor || busy)
            return;
        setBusy(true);
        setError('');
        try {
            const page = await api(`/reports/${report.id}/activity?before=${cursor}`);
            setEvents(current => [...current, ...page.items]);
            setCursor(page.next_cursor);
        }
        catch (e) {
            setError(e instanceof Error ? e.message : 'Unable to load history');
        }
        finally {
            setBusy(false);
        }
    }
    return _jsxs(_Fragment, { children: [_jsx("ol", { children: events.map(event => _jsxs("li", { children: [new Date(event.occurred_at).toLocaleString(), " \u00B7 Cycle ", event.cycle, " \u00B7 ", event.kind.replaceAll('_', ' '), event.note ? ` · ${event.note}` : ''] }, event.id)) }), error ? _jsx("p", { role: "alert", children: error }) : null, cursor ? _jsx("button", { disabled: busy, onClick: () => void more(), children: "Load older Report activity" }) : null] });
}
